import { render, staticRenderFns } from "./SimilarArticles.vue?vue&type=template&id=b8ab48ca&scoped=true&"
import script from "./SimilarArticles.vue?vue&type=script&lang=ts&"
export * from "./SimilarArticles.vue?vue&type=script&lang=ts&"
import style0 from "./SimilarArticles.vue?vue&type=style&index=0&id=b8ab48ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../home/bearlogin/development/pinq-project/mono2/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ab48ca",
  null
  
)

export default component.exports